// extracted by mini-css-extract-plugin
module.exports = {"icon":"mini-round-history_icon__3eiPb"};